export * from "-!../../../../node_modules/babel-loader/lib/index.js!../../../../node_modules/vue-loader/lib/loaders/templateLoader.js??ref--2!../../../../node_modules/vue-loader/lib/index.js??vue-loader-options!./MainSlider.vue?vue&type=template&id=1c541138&scoped=true"


//////////////////
// WEBPACK FOOTER
// ./Scripts/app/main-slider/components/MainSlider.vue?vue&type=template&id=1c541138&scoped=true
// module id = 515
// module chunks = 0